( function ( $ ) {

  let $category_button;
  let $category_menu;

  function insta_toggle ( open ) {
    $category_button.addClass( 'no-trans' );
    setTimeout( function () {
      $category_button.removeClass( 'no-trans' );
    }, 0 );
    $category_button.attr( 'aria-expanded', open ? 'true' : 'false' );
    $category_menu.toggle( open );
  }

  $( function () {
    $category_button = $( '.category-button' );
    $category_menu = $( '.category-menu' );

    $category_button.click( function () {
      let opening = $(this).attr( 'aria-expanded' ) != 'true';
      $(this).attr( 'aria-expanded', opening ? 'true' : 'false' );
      $category_menu[ opening ? 'slideDown' : 'slideUp' ]();
    });

    ThemeJS.Media_Queries.watch( 'md', function ( e ) {
      insta_toggle( e.matches );
    });
  });

})( jQuery );